module.exports = __webpack_public_path__ + "media/images/b2b_admin/mailer/logo-blue-with-name-cedf7014aa3944036a752d7c01be14a3.png";